import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import FormDateField from 'common/form-date-field';
import FormPhoneField from 'common/form-phone-field';
import FormTextField from 'common/form-text-field';

import { AssignedTaskMatterInfoType } from './assigned-task-matter-info';

const useStyles = makeStyles(() => ({
  headerText: {
    display: 'flex',
    alignItems: 'center',
  },
  columnHeader: {
    width: '250px',
  },
  column: {
    display: 'flex',
    width: '100%',
    padding: '20px 0',
    borderBottom: '1px solid #ECEEF1',
    alignItems: 'center',
  },
  columnBody: {
    display: 'flex',
    flex: 1,
  },
  fieldRequired: {
    color: 'red',
  },
}));

const AssignedTaskMatterInfoTruproxyForm = () => {
  const classes = useStyles();

  const {
    formState: { errors },
    control,
  } = useFormContext<AssignedTaskMatterInfoType>();

  return (
    <>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>
            <span className={classes.fieldRequired}>*</span> First Name
          </Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardFirstName"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                autoFocus
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.wardFirstName?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>
            <span className={classes.fieldRequired}>*</span> Last Name
          </Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardLastName"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.wardLastName?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Social Security Number</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardSsn"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.wardSsn?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Street</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardAddressStreet"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.wardAddressStreet?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>City</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardAddressCity"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.wardAddressCity?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>State</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardAddressState"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.wardAddressState?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Zip</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardAddressZip"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 10 }}
                errorMessage={errors.estateTruproxyFields?.wardAddressZip?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Date of Birth</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.wardDateOfBirth"
            control={control}
            render={({ field: { value, onChange, name } }) => (
              <FormDateField
                {...{ value, onChange, name }}
                errorMessage={
                  (errors.estateTruproxyFields?.wardDateOfBirth?.message as string) || undefined
                }
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Fidicuary First Name</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.clientFirstName"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                autoFocus
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.clientFirstName?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Fidicuary Last Name</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.clientLastName"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.clientLastName?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Fidicuary Email Address</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.clientEmailAddress"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                inputProps={{ maxLength: 80 }}
                errorMessage={errors.estateTruproxyFields?.clientEmailAddress?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Fidicuary Phone Number</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTruproxyFields.clientPhoneNumber"
            control={control}
            render={({ field: { name, onBlur, onChange, value } }) => (
              <FormPhoneField
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                errorMessage={errors.estateTruproxyFields?.clientPhoneNumber?.message}
                label="Phone Number"
              />
            )}
          />
        </div>
      </div>
    </>
  );
};

export default AssignedTaskMatterInfoTruproxyForm;
